import { render, staticRenderFns } from "./UnitPCBSchema.vue?vue&type=template&id=3fcf7db1&scoped=true&"
import script from "./UnitPCBSchema.vue?vue&type=script&lang=js&"
export * from "./UnitPCBSchema.vue?vue&type=script&lang=js&"
import style0 from "./UnitPCBSchema.vue?vue&type=style&index=0&id=3fcf7db1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf7db1",
  null
  
)

export default component.exports